export const selectCountryList = (state) => state?.country?.getCountryList?.data || [];
export const selectCountryListLoading = (state) => state?.country?.getCountryList?.loading || false;
export const selectCountryListError = (state) => state?.country?.getCountryList?.error || null;

export const selectStateList = (state) => state?.country?.getStateList?.data || [];
export const selectStateListLoading = (state) => state?.country?.getStateList?.loading || false;
export const selectStateListError = (state) => state?.country?.getStateList?.error || null;

export const selectCityList = (state) => state?.country?.getCityList?.data || [];
export const selectCityListLoading = (state) => state?.country?.getCityList?.loading || false;
export const selectCityListError = (state) => state?.country?.getCityList?.error || null;

export const selectCountryState = (state) => state?.country;